import React from 'react';
import { InputGroup, Input } from 'reactstrap';

export function LookupFilter(props) {
  const { handleChange } = props;
  return (
    <InputGroup>
      <Input name="terms" onChange={handleChange} placeholder="Filter results" />
    </InputGroup>
  );
}
